export interface IExpertSystemDonor {
    registrationId: number; 
    donorId: number;  
    centerId: number;  
    alias: string;  
    firstName: string;
    lastName: string;  
    address1: string;  
    address2: string; 
    city: string; 
    state: string; 
    postalCode: string; 
    birthDate: string; 
    recipientId: number; 
    gender: string; 
}
